import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=58b190f2&scoped=true&"
import script from "./ContentSection.vue?vue&type=script&lang=ts&"
export * from "./ContentSection.vue?vue&type=script&lang=ts&"
import style0 from "./ContentSection.vue?vue&type=style&index=0&id=58b190f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b190f2",
  null
  
)

export default component.exports